import api from './api';

export interface BuiltinSkill {
  name: string;
  description: string;
  tools: string[];
}

export interface BuiltinSkillContent {
  name: string;
  content: string;
  readonly: boolean;
}

export async function listBuiltinSkills(): Promise<BuiltinSkill[]> {
  const response = await api.get('/skills/builtin');
  return response.data.skills;
}

export async function getBuiltinSkill(name: string): Promise<BuiltinSkillContent> {
  const response = await api.get(`/skills/builtin/${name}`);
  return response.data;
}
